import React, { useContext, useEffect, useState } from 'react';
import i18n from '../../../../../i18n';
import { getStripePublishableKey } from '../../../../../backend-api';
import retryOperation from '../../../../../utilities/retryOperation';
import { logError } from '../../../../../utilities/log';

const StripeContext = React.createContext();

const StripeProvider = ({ children }) => {
  const [stripe, setStripe] = useState(null);

  useEffect(() => {
    const loadStripeObject = async () => {
      const { publishableKey } = await getStripePublishableKey();
      const { loadStripe } = require('@stripe/stripe-js');
      const stripe = await loadStripe(publishableKey, {
        locale: i18n.locale,
      });
      setStripe(stripe);
    };
    const tryLoadingStripeObject = async () => {
      try {
        await retryOperation(loadStripeObject, 100, 10);
      } catch (ex) {
        logError('Courses/StripeProvider', 'Error initializing Stripe', { message: ex.message });
        alert('Could not connect to Stripe.');
      }
    };
    tryLoadingStripeObject();
  }, []);

  return <StripeContext.Provider value={stripe}>{children}</StripeContext.Provider>;
};

export default StripeProvider;

// Allows accessing Stripe context without need to create Elements
export const useStripeContext = () => {
  return useContext(StripeContext);
};
